import React, { useState, useEffect, useRef } from "react";
import { Typography } from "@mui/material";
import {
  generateOrderedList,
  referenceHtml,
  referenceTootKit,
  generateUnOrderedList,
  sectionStyle,
  h1style,
  h2style,
  paraStyle,
  DividerBorderStyle,
  DashedBorderStyle,
  referenceStyle,
} from "./ChapterList";

import Zoom from "react-medium-image-zoom";

import "react-medium-image-zoom/dist/styles.css";
import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import "../JaldiLab.css";
import LeftArrow from "../../../assets/SvgIcons/LeftArrow.svg";
// import RightArrow from "../../../assets/SvgIcons/RightArrow.svg";

const DesignAndImplementation = ({ goToSection }) => {
  const referencesRef = useRef(null);
  const reference = (_data, number) => {
    return referenceTootKit(_data, number, handleScrollToReferences);
  };
  const generateCustomOrderedList = (_stringsArray, type) => {
    return (
      <Typography>
        <ol type={type}>
          {_stringsArray.map((text, index) => (
            <li style={{ ...pointStyle, paddingLeft: "10px" }} key={index}>
              {text}
            </li>
          ))}
        </ol>
      </Typography>
    );
  };

  const handleScrollToReferences = () => {
    if (referencesRef.current) {
      referencesRef.current.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
    }
  };
  const pointStyle = {
    fontFamily: "Lato",
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "27px",
    color: "#555555",
    letterSpacing: "0em",
    textAlign: "justified",
    margin: "10px 30px",
  };
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
    }
  };
  const referenceData = [
    {
      content:
        "The Department of Justice has been implementing the Centrally Sponsored Scheme (“CSS”) for development of infrastructure facilities since 1993-94, to augment the resources of the State Governments for constructing Court buildings and residential accommodation for Judicial Officers. For further details on funds allocation see: CSS for Judicial Infrastructure (2012).",
    },
    { content: "NCMS (2012), p. 7." },
    {
      content:
        "The process outlined in this section has been proposed after consultations with Court officials, Judges and urban planners. ",
    },
    { content: "NCMS (2012). " },
  ];
  const preDesignArray = [
    <>
      The criteria for site selection should be developed to ensure that the
      required facilities that cannot be accommodated within the site Master
      Plan are easily accessible in the vicinity. Site selection criteria may
      include ensuring easy public access and avoiding eco-sensitive zones.
    </>,

    <>
      <p style={paraStyle}>
        A Phasing Plan that outlines the phases of construction should be
        prepared. Site planning principles should be followed to prepare the
        layout of buildings in the Master Plan.
      </p>
      <p style={paraStyle}>
        The non-negotiable design principles and related set of guidelines, as
        defined in this Handbook in{" "}
        <span
          style={sectionStyle}
          onClick={() => {
            goToSection("designPrinciples", "Principle");
          }}
        >
          PART B
        </span>
        , may be used as a framework to ascertain the functional, spatial and
        infrastructural requirements of the District Court Complex.
      </p>
    </>,
    "To ascertain the functional requirements of the District Court Complex, a Stakeholder Engagement Plan should be prepared which identifies all concerned stakeholders and users of the Court, and experts involved in the decision making process. This plan should outline how to engage with various government authorities, the Judicial Officers and staff, and all users of the Court Complex throughout the various stages of the design process.",
    // <>
    //   <p style={paraStyle}>
    //     Stakeholder surveys should be designed to gather inputs from judges,
    //     lawyers, litigants, staff, vulnerable groups, accused, and members of
    //     the public on space design and infrastructure requirements. This would
    //     also help with ascertaining the functional and infrastructural needs and
    //     corresponding space requirements in relation to the plan and its
    //     targets, to determine overall built up area required for the District
    //     Court Complex.{" "}
    //   </p>
    //   <p style={paraStyle}>
    //     The non-negotiable design principles and related set of guidelines, as
    //     defined in this Handbook in{" "}
    //     <span
    //       style={sectionStyle}
    //       onClick={() => {
    //         goToSection("designPrinciples", "Principle");
    //       }}
    //     >
    //       Part B
    //     </span>
    //     , may be used as a framework to ascertain the functional, spatial and
    //     infrastructural requirements of the District Court Complex.
    //   </p>
    // </>,

    "Stakeholder surveys should be designed to gather inputs from Judges, lawyers, litigants, staff, vulnerable groups, Accused Persons, and members of the public on space design and infrastructure requirements. This would help with ascertaining the functional and infrastructural needs and corresponding space requirements in relation to the plan, to determine the overall built up area required for the District Court Complex. This would also ensure that the proposed design is responsive to the needs of diverse user groups.",

    "The spatial requirements and infrastructure needs determined through the stakeholder assessment of requirements should be used to prepare the Design Brief for the project. It should also determine the scope of work, and prepare broad budget estimates for design and construction. The budget estimates should include the requirements for implementing the project, operating & maintaining, managing and monitoring the Court facilities, and conducting regular audits. ",

    "In addition to building construction professionals (planners, architects, landscape architects, interior designers, structural engineers, Mechanical, Engineering and Plumbing (“MEP”) consultants, etc.), other specialised consultants in areas such as security, universal design, wayfinding and signage, IT infrastructure provision, facilities management, accessibility compliance, waste management systems, and other relevant consultants should be involved. This would ensure comprehensive planning and implementation.",

    "For the preparation of a Site Plan, a preliminary site analysis that involves understanding the plot of land, its constraints and contextual conditions, the applicable local land use zoning restrictions and building regulations, should be undertaken. Preliminary sketches of the site plan and basic building design ideas should be created at this stage.",
  ];
  const designArray = [
    "The Building Committee, along with the design consultants/team of experts selected, should use the feedback from various stakeholders to prepare a draft concept plan, to suit the chosen site and its context, with the necessary adjacencies of functions and facilities. The draft concept plan may further be improved after consultations with all stakeholders to prepare the final plan. ",

    "It is essential to ensure that the key design principles identified in the vision are met in the final plan through a set of related guidelines. Additionally, the standards for spaces within the Court Complex and specific design considerations along with the users and desirable adjacencies of functions should be considered in finalising the building floor plans and sections.",
    "Preparation of a DPR with construction drawings and documents for tendering including site plan, floor plans, sections, elevations and bill of quantities should be prepared.",
  ];

  const constructionArray = [
    "A construction agency empanelled with the PWD should be onboarded to execute the plans and conduct Project inspection and management. ",

    "Additionally, a separate Monitoring Cell comprised of the PDJ, architects and design/construction experts and project management consultants may be constituted, to assist the Building Committee in systematically reviewing the construction process. ",
  ];

  const implementationArray = [
    <>
      Preparing standard operating procedures and implementation policies for
      the operations and management of building facilities before occupancy is
      crucial (
      <span
        style={sectionStyle}
        onClick={() => {
          goToSection("siteBuildingManagement", "buildingManagementSystems");
        }}
      >
        Section 2.3
      </span>
      );
    </>,
    <>
      Building institutional capacity of staff, Judicial Officers and others
      concerned for ensuring smooth management and operation of facilities, and
      sensitising them to standard operating procedures and needs of diverse
      stakeholders (
      <span
        style={sectionStyle}
        onClick={() => {
          goToSection("capacityBuilding", "mainheading");
        }}
      >
        Section 5
      </span>
      ); and
    </>,
    <>
      Preparing survey, audit and evaluation frameworks for assessing the needs
      of diverse user groups based on the design principles and guidelines (
      <span
        style={sectionStyle}
        onClick={() => {
          goToSection("monitoringEvaluation", "mainheading");
        }}
      >
        Section 6
      </span>
      ).{" "}
    </>,
  ];
  const implementationOuterArray = [
    <>
      A committee for Court facilities management and appointment of Facility
      Manager/Management Agency (for further details, please refer to{" "}
      <span
        style={sectionStyle}
        onClick={() => {
          goToSection("siteBuildingManagement", "siteAndBuildin");
        }}
      >
        Section 2.4
      </span>
      ) should be constituted through a tendering process to ensure adequate
      maintenance of the Court Complex.{" "}
    </>,
    <>
      The other aspects to be covered in this stage include:
      {generateCustomOrderedList(implementationArray, "i")}
    </>,
  ];

  const MonitoringArray = [
    "An independent research body may be engaged by the High Court Building Committee to undertake review and monitoring of the implementation of the Design Principles and guidelines annually. The research body should consist of a multi-disciplinary committee of experts with experience in working with diverse user groups and vulnerable witnesses.",
    "Stakeholder consultation should be undertaken to assess the building operations, and the functioning of the Court system and its infrastructure facilities using the audit and evaluation frameworks provided in this Handbook.  It is recommended that the stakeholder consultations must be held on a periodic basis, which may be fixed by the Building Committee to be bi-annual or annual.",
    <>
      A cost-benefit analysis should be undertaken to compare the intangible
      benefits of the Court building such as greater access to justice,
      increased satisfaction of the various stakeholders, efficient delivery of
      justice, etc., with the financial costs and other social costs.
      {reference(referenceData[2], 3)}
    </>,
    <>
      A post-occupancy evaluation should be undertaken to prepare a
      post-occupancy assessment report. Typically the assessment must be
      undertaken after 12 to 18 months of the occupation of the buildings. For
      further details, please refer to{" "}
      <span
        style={sectionStyle}
        onClick={() => {
          goToSection("monitoringEvaluation", "framework");
        }}
      >
        Section 6.2.{" "}
      </span>
    </>,
  ];

  const tableStyle = {
    fontFamily: "Lato",
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "27px",
    color: "#555555",
    letterSpacing: "0em",
    textAlign: "justified",
    margin: 0,
  };

  return (
    <div>
      <Typography>
        <h1 id="partD" style={h1style}>
          PART D - IMPLEMENTATION, MONITORING & EVALUATION
        </h1>
        <h2 style={h2style}>
          <span style={{ fontSize: "24px" }}>1. </span>DESIGN AND IMPLEMENTATION
          PROCESS
        </h2>
        <p style={paraStyle}>
          Typically, once the decision to construct a District Court Complex is
          initiated through a High Court order, the Building Committee selects
          the land and assigns the state Public Works Department (“PWD”) to
          prepare a phase-wise plan for constructing the new building Complex.
          Funds are allocated for the construction jointly by the Central
          Government and the State Government.{reference(referenceData[0], 1)} A
          Master Plan with building designs and Detailed Project Report (“DPR”)
          for design and construction of the new Court Complex is prepared,
          which is submitted to the Building Committee of the High Court.
        </p>
        <p style={paraStyle}>
          A Court Development Plan, Vision and Objectives are prepared for the
          District Court. Short-term (annual), medium-term (five-year) and
          long-term plans are set with a vision statement for a 10-year period.
          {reference(referenceData[1], 2)} Targets to be achieved through
          objectives and measurable quantitative as well as qualitative goals
          are also identified. This provides a direction for preparing the
          District Court space and infrastructure requirements. The Building
          Committee (High Court) oversees the design, construction and
          implementation of the District Court Plan.
        </p>
        <p style={paraStyle}>
          This Handbook seeks to serve as a ready reference for the Building
          Committees (High Court) and the PWD when formulating the Vision,
          objectives, plans, and implementation process of a new District Court
          Complex with a user-centric design approach. This section provides
          recommendations for implementing the design of a new District Court
          Complex within the framework of a typical building design process.
        </p>
        <p style={paraStyle}>
          The following outlines the stages in a typical design process and the
          additional processes which may be followed under each stage for
          implementation of the recommendations of this Handbook:
          {reference(referenceData[2], 3)}
        </p>
        <DividerBorderStyle />
        <h3 id="stage1">
          <i>Stage 1: Pre-Design</i>
        </h3>
        {generateCustomOrderedList(preDesignArray, "a")}
        <DividerBorderStyle />
        <h3 id="stage2">
          <i>Stage 2: Design</i>
        </h3>
        {generateCustomOrderedList(designArray, "a")}
        <DividerBorderStyle />
        <h3 id="stage3">
          <i>Stage 3: Construction</i>
        </h3>
        {generateCustomOrderedList(constructionArray, "a")}
        <DividerBorderStyle />
        <h3 id="stage4">
          <i>Stage 4: Implementation of Policy Procedures</i>
        </h3>
        {generateCustomOrderedList(implementationOuterArray, "a")}
        <DividerBorderStyle />
        <h3 id="stage5">
          <i>Stage 5: Monitoring and Evaluation</i>
        </h3>
        {generateCustomOrderedList(MonitoringArray, "a")}
        <p style={paraStyle}>
          The Audit framework provided in this Handbook will provide a useful
          tool to assess the status of the Court after it is occupied.
          Additionally, the user experience survey based on the set of design
          guidelines outlined in this Handbook will assist in a qualitative
          evaluation of the Court Complex, which will assess the extent to which
          the design principles have been met. For further details, please refer
          to
          <span
            style={sectionStyle}
            onClick={() => {
              goToSection("monitoringEvaluation", "mainheading");
            }}
          >
            {" "}
            Section 6.
          </span>
        </p>
        <p style={paraStyle}>
          The recommendations for an ideal design process outlined in the
          Handbook are in accordance with the Targets of selected Sustainable
          Development Goals (“SDGs”) set out by the United Nations which have
          been adopted by India. For further details, please refer to{" "}
          <span
            style={sectionStyle}
            onClick={() => goToSection("annexes", "HeadingAnnexure7")}
          >
            Annexure 7
          </span>
          .
        </p>

        <h2 ref={referencesRef} id="designRef" style={referenceStyle}>
          <i>References</i>
          <Divider />
        </h2>
        {referenceHtml(referenceData)}
      </Typography>
    </div>
  );
};

export default DesignAndImplementation;
